import { render } from "./ContactAutocomplete.vue?vue&type=template&id=4f3641d3"
import script from "./ContactAutocomplete.vue?vue&type=script&lang=js"
export * from "./ContactAutocomplete.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__